import { html, LitElement, nothing, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TrackableEventAction } from '../../../app/package/base/service/tracking/tracking-service';
import { I18n } from '../../base/package/services/package/i18n/i18n.de';
import baseThemeStyle from '../../base/package/themes/de-games/base-theme.css?inline';
import { handleKeyboardTrigger } from '../../base/package/util/a11y';
import { dispatchCustomEvent } from '../../base/package/util/event';
import { openGamification } from '../../mod-incentive/helper/gamification-launcher';
import { NavBarIconLayout, NavBarIconName } from '../nav-bar/ui-nav-bar-icon';
import styles from './ui-game-navigation-desktop.css?inline';
import '../nav-bar/ui-gamification-icon';

const CName = 'ui-game-navigation-desktop';

/**
 * @fires showDiscovery - When the discovery icon is clicked
 * @fires showQuickDeposit - When the deposit icon is clicked
 */
@customElement(CName)
export class UiGameNavigationDesktop extends LitElement {
  static readonly styles = [unsafeCSS(styles), unsafeCSS(baseThemeStyle)];

  @property({ type: Boolean }) shouldShowGamificationIcon = false;

  render() {
    return html`
      <ul class="toolbar">
        <li>
          <ui-nav-bar-icon
            .class=${'game-nav'}
            .icon=${NavBarIconName.DISCOVER}
            .layout=${NavBarIconLayout.HORIZONTAL}
            @click=${() => this._handleGameBottomBarClick(NavBarIconName.DISCOVER)}
            @keydown=${(ev: KeyboardEvent) => handleKeyboardTrigger(ev, this._handleGameBottomBarClick.bind(this, NavBarIconName.DISCOVER))}
            label=${window.$app.appSettings.isSHCasino ? window.$app.$t.get(I18n.navigation.navbar.leave) : window.$app.$t.get(I18n.navigation.navbar.discover)}
          ></ui-nav-bar-icon>
        </li>
        <li>
          ${this.shouldShowGamificationIcon ? this._renderGamificationIcon() : nothing}
        </li>
        <li>
          <ui-nav-bar-icon
            .class=${'game-nav'}
            .icon=${NavBarIconName.DEPOSIT}
            .layout=${NavBarIconLayout.HORIZONTAL}
            @click=${() => this._handleGameBottomBarClick(NavBarIconName.DEPOSIT)}
            @keydown=${(ev: KeyboardEvent) => handleKeyboardTrigger(ev, this._handleGameBottomBarClick.bind(this, NavBarIconName.DEPOSIT))}
            label=${window.$app.$t.get(I18n.navigation.navbar.deposit)}
          ></ui-nav-bar-icon>
        </li>
      </ul>
    `;
  }

  private _renderGamificationIcon() {
    return html`
      <button class="gamification" @click=${this._handleMissionClick}>
        <ui-gamification-icon
          ?isActive=${true}
        ></ui-gamification-icon>
        <span>${window.$app.$t.get(I18n.navigation.navbar.missions)}</span>
      </button>`;
  }

  private _handleMissionClick() {
    window.$app.track.menuNavigation({
      eventAction: TrackableEventAction.GAMIFICATION_ICON,
      navMode: 'gameMode',
    });
    openGamification(true);
  }

  private _handleGameBottomBarClick(name: NavBarIconName) {
    window.$app.track.menuNavigation({
      eventAction: name,
      navMode: 'gameMode',
    });
    switch (name) {
      case NavBarIconName.DISCOVER:
        dispatchCustomEvent(this, 'showDiscovery');
        break;
      case NavBarIconName.DEPOSIT:
        dispatchCustomEvent(this, 'showQuickDeposit');
        break;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UiGameNavigationDesktop;
  }
}
